import { render, staticRenderFns } from "./IndexWeb.vue?vue&type=template&id=f656341e&scoped=true&"
import script from "./IndexWeb.vue?vue&type=script&lang=js&"
export * from "./IndexWeb.vue?vue&type=script&lang=js&"
import style0 from "./IndexWeb.vue?vue&type=style&index=0&id=f656341e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f656341e",
  null
  
)

export default component.exports